import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import { MdAddShoppingCart } from "react-icons/md";
import "./style.css";
import { useNavigate, useParams } from "react-router";
import { toast } from "react-toastify";
import noavatar from "../../../assets/img/noavatar.png";
import { getData, postData, putData } from "../../../api/method";

const username = localStorage.getItem("username");

function ProductDetail() {
  const { id } = useParams();

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [cart, setCart] = useState([]);
  const [count, setCount] = useState();
  const [idCart, setIdCart] = useState();

  const getProduct = async () => {
    try {
      const result = await getData(`/api/Product/${id}`);
      setData(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCart = async () => {
    try {
      const result = await getData(`/api/Cart/user/${username}`);
      setCart(result.data);
    } catch (error) {
      console.log(error);
    }

    const productExist = cart.find((item) => item.productId === data.id);
    setCount(productExist.quantity);
    setIdCart(productExist.id);
  };

  useEffect(() => {
    getProduct();
    getCart();
  }, [cart]);

  const handleSubmitAdd = async () => {
    if (data.quantity > 0) {
      const formData = new FormData();

      formData.append("userId", username);
      formData.append("productId", id);
      formData.append("quantity", 1);

      try {
        const res = await postData("/api/Cart", formData);
        if (res.status === 200) {
          toast.success("Add to cart success!");
          navigate("/cart");
        }
      } catch (err) {
        console.log(err);
        toast.error("Add to cart fail!");
      }
    } else {
      toast("Product is sold out!");
    }
  };

  const handleSubmitEdit = async () => {
    const formEdit = new FormData();

    formEdit.append("id", idCart);
    formEdit.append("userId", username);
    formEdit.append("productId", id);
    formEdit.append("quantity", count + 1);

    try {
      const res = await putData(`/api/Cart/${idCart}`, formEdit);
      if (res.status === 200) {
        toast.success("Add to cart success!");
        navigate("/cart");
      }
    } catch (err) {
      console.log(err);
      toast.error("Add to cart fail!");
    }
  };

  const handleSubmitAddToCart = async (product) => {
    const ProductExist = cart.find((item) => item.productId === product.id);
    if (ProductExist) {
      handleSubmitEdit();
    } else {
      handleSubmitAdd();
    }
  };

  return (
    <div className="d-flex align-items-start justify-content-between">
      <div className="img_product_info border_product">
        <img
          src={`${process.env.REACT_APP_URL_IMAGE + data.image}` || noavatar}
          alt="product"
          width="100%"
          height="100%"
        />
      </div>

      <div className="product_detail ms-5">
        {data.quantity === 0 ? (
          <div className="pb-2 d-flex align-items-center">
            <span className="fs-5 error">&#9753; Sold out</span>
          </div>
        ) : (
          <></>
        )}

        <div>
          <p className="fs-4 pb-2">{data?.category?.name}</p>
          <p className="fs-2 name_product_info">{data.name}</p>
        </div>

        <div className="pt-4 d-flex align-items-center">
          <span className="fs-5 me-3">Price: </span>
          <p className="fs-5 fw-bold t-primary me-4">
            {((data.price * (100 - data.discount)) / 100).toLocaleString("vi")}
            &#273;
          </p>
          <p className="price_sale_info fs-18 fw-bold">
            {(data.price * 1).toLocaleString("vi")}&#273;
          </p>
        </div>

        <div className="pt-3 d-flex align-items-center">
          <span className="fs-5">Discount:</span>
          <span className="ms-3 fw-bold btn-capacity">{data.discount}%</span>
        </div>

        <div className="pt-3 d-flex align-items-center">
          <span className="fs-5">Dimension:</span>
          <span className="ms-3 fw-bold btn-capacity">{data.dimension}ml</span>
        </div>

        <div className="pt-4">
          <Button
            className="fs-20 t-primary btn_add_cart"
            onClick={() => handleSubmitAddToCart(data)}
          >
            <MdAddShoppingCart /> Add to cart
          </Button>
          <Button className="fs-20 t-white btn_buy ms-4">Buy now</Button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
